import "./exercise-type.scss"
import { EXERCISE_TYPE_LABELS, exerciseTypeOf } from "../../../data-utils/exerciseType"

const CLASS = { ctf: "ctf", training: "trn", assessment: "asm", mixed: "mix" }

// The Type chip shown on every exercise / report row (CTF reports spec §1). Colour is never the
// only signal: the text label is always present; the CTF flag glyph is decorative.
const ExerciseTypeBadge = ({ type = null, row = null, className = "" }) => {
  const resolved = type ?? row?.exerciseTypeResolved ?? exerciseTypeOf(row)
  const label = EXERCISE_TYPE_LABELS[resolved] ?? EXERCISE_TYPE_LABELS.assessment
  return (
    <span className={`ct-type-chip ${CLASS[resolved] ?? "asm"} ${className}`.trim()} data-exercise-type={resolved}>
      {resolved === "ctf" ? <span aria-hidden="true">{"⚑ "}</span> : null}
      {label}
    </span>
  )
}

export default ExerciseTypeBadge
